<ng-container *transloco="let t; read: 'documents.entity-editor'">
  @if (!deletePressed) {
    <label for="entity-input" class="kxi-text-large">{{ t('entity') }}</label>
    <div class="entity-editor__entity-input-wrapper">
      <xi-input-field
        [(ngModel)]="entity.title"
        [placeholder]="t('enter-here')"
        id="entity-input"
        #entityInput="ngModel"
        [status]="
          entityInput.touched && (!entityInput.value || entityInput.value.trim() === '')
            ? { state: 'error' }
            : undefined
        "
      ></xi-input-field>
    </div>
    <label for="type-select" class="kxi-text-large">{{ t('type') }}</label>
    <div class="entity-editor__entity-input-wrapper">
      <xi-dropdown
        [(ngModel)]="entity.entityType"
        [data]="entityTypes"
        [stretch]="true"
        id="type-select"
        [placeholder]="t('select')"
        #entityTypeDropdown="ngModel"
        [status]="
          entityTypeDropdown.touched && !entityTypeDropdown.value ? { state: 'error' } : undefined
        "
      ></xi-dropdown>
    </div>
    <div class="configuration-buttons-container" [matTooltip]="editConfigButtonTooltip">
      @if (entity.type === 'named') {
        <div>
          <xi-default-button
            [text]="t('edit-blacklist')"
            fill="text"
            [hasAnimation]="false"
            [disabled]="!canEditConfig"
            (onClick)="editConfig('blacklist')"
          ></xi-default-button>
        </div>
      }
      <xi-default-button
        [text]="t('edit-entities')"
        fill="text"
        [hasAnimation]="false"
        [disabled]="!canEditConfig"
        (onClick)="editConfig('entities')"
      ></xi-default-button>
    </div>
    <app-sentiment-control
      [projectId]="projectId()"
      [sentimentScale]="sentimentScale()"
      [sentimentScore]="entity.sentimentScore"
      [sentimentValue]="sentimentValue"
      sentimentRangeType="feature"
      (manualSentimentChange)="onSentimentChanged($event)"
    ></app-sentiment-control>
  } @else {
    <h3>{{ t('delete-entity-title') }}</h3>
    <p>{{ t('delete-entity-content', { title: entity.title, type: entity.entityType }) }}</p>
    <ng-container *ngTemplateOutlet="comments"></ng-container>
  }

  <div class="entity-editor__buttons-container">
    <xi-default-button
      [text]="t('cancel')"
      fill="text"
      [hasAnimation]="false"
      (onClick)="cancelEntity()"
    ></xi-default-button>

    @if (entityToEdit().id && !hasChanges()) {
      <div>
        <xi-default-button
          [text]="t('delete')"
          fill="text"
          [hasAnimation]="false"
          color="warning"
          [disabled]="isLoading()"
          (onClick)="deleteEntity()"
        >
        </xi-default-button>
      </div>
    }
    @if (!deletePressed) {
      <div>
        <xi-default-button
          [text]="t('save')"
          color="CX"
          fill="text"
          [hasAnimation]="false"
          [disabled]="isLoading() || !formValid() || !hasChanges()"
          (onClick)="saveEntity()"
        ></xi-default-button>
      </div>
    }
  </div>

  @if (hasChanges()) {
    <ng-container *ngTemplateOutlet="comments"></ng-container>
  }

  <ng-template #comments>
    <h3>{{ t('comments') }}</h3>

    <div class="full-width entity-editor__text-area-container">
      <xi-text-area
        ngDefaultControl
        [(ngModel)]="comment"
        name="comment"
        [placeholder]="t('leave-comment')"
        [height]="100"
      ></xi-text-area>
    </div>
  </ng-template>
</ng-container>
